import React from "react";
import { ArrowRightIcon, LockIcon } from "lucide-react";
import { CHECKOUT_URL } from "../data/content";
type CTAButtonProps = {
  label: string;
  id?: string;
  showMeta?: boolean;
  pulse?: boolean;
};
export function CTAButton({
  label,
  id,
  showMeta = true,
  pulse = false
}: CTAButtonProps) {
  return <div id={id} className="flex w-full flex-col items-center" data-id="element-27" data-mp="2fyjwp2l0dcci">
      <a href={CHECKOUT_URL} className={`group flex w-full max-w-xl items-center justify-center gap-3 rounded-2xl bg-cta px-5 py-5 text-center font-display text-[17px] font-black uppercase leading-tight tracking-tight text-ink shadow-[0_10px_0_0_#b88a00] transition-[transform,background-color,box-shadow] duration-150 ease-out hover:bg-cta-hover active:translate-y-[6px] active:shadow-[0_4px_0_0_#b88a00] focus:outline-none focus-visible:ring-4 focus-visible:ring-brand sm:text-xl ${pulse ? "animate-cta-pulse" : ""}`} data-id="element-28" data-mp="2tzct5suvehi9">
        <span data-id="element-29" data-mp="38pk1vgv2sm5r">{label}</span>
        <ArrowRightIcon className="h-6 w-6 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden data-id="element-30" data-mp="38m5zi8mewcyb" />
      </a>
      {showMeta && <p className="mt-5 flex flex-wrap items-center justify-center gap-x-2 gap-y-1 text-center text-[13px] font-medium text-mist" data-id="element-31" data-mp="1db9mvnt84xwm">
          <LockIcon className="h-3.5 w-3.5" aria-hidden data-id="element-32" data-mp="1ibnxndm7mlyc" />
          <span data-id="element-33" data-mp="1n9pd7okfg352">One-time payment of $27 USD</span>
          <span aria-hidden data-id="element-34" data-mp="1n6bdyp728a1u">·</span>
          <span data-id="element-35" data-mp="1s8k8hpzkzk62">Immediate access</span>
          <span aria-hidden data-id="element-36" data-mp="1s7ik6jtk116e">·</span>
          <span data-id="element-37" data-mp="1w944gq8f4hqm">7-Day Guarantee</span>
        </p>}
    </div>;
}